import { composeStyle } from '@xhs/yam-beer/core/system/compose'
import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

const disabledState = '&[disabled]'
const hoverState = '&:not([disabled]):hover, &:not([disabled])[data-hover]'
const activeState = '&:not([disabled]):active, &:not([disabled])[active]'

const TEXT_DECORATION = {
  content: '""',
  height: 1,
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: '-2px',
  bg: 'palette.brand.disable',
  transformOrigin: '50% 100%',
  transform: 'scale(1, 0.5)',
}

export default function initStyle() {
  return [
    registerThemeSpec(
      'cmp.textType',
      {
        '.text-code': {
          mx: 4,
          p: 4,
          fontSize: '85%',
          background: 'rgba(150,150,150,.1)',
          border: '1px solid rgba(100,100,100,.2)',
          borderRadius: '3px',
        },
        kbd: {
          mx: 4,
          p: 4,
          fontSize: '85%',
          background: 'rgba(150,150,150,.1)',
          border: '1px solid rgba(100,100,100,.2)',
          borderRadius: '3px',
        },
        mark: {
          bg: 'palette.warn.base',
        },
        u: {
          textDecoration: 'underline',
        },
        del: {
          textDecoration: 'line-through',
        },
        strong: {
          fontWeight: 'medium',
        },
      },
    ),
    registerThemeSpec(
      'cmp.textStyle',
      composeStyle.switch('variant')
        .case('h2', {
          fontSize: '24px',
          lineHeight: '32px',
          fontWeight: 'medium',
          mt: 0,
          mb: '3x',
        })
        .case('h3', {
          fontSize: '16px',
          lineHeight: '26px',
          fontWeight: 'medium',
          mt: 0,
          mb: '4xs',
        })
        .case('body', {
          fontSize: '14px',
          lineHeight: '22px',
          fontWeight: 'normal',
          color: 'body',
          mb: '14px',
        })
        .case('mute', {
          fontSize: '12px',
          lineHeight: '18px',
          fontWeight: 'normal',
          mb: '12px',
          color: 'mute',
        })
        .case('h28', {
          fontSize: 28,
          fontWeight: 'medium',
        })
        .case('h20', {
          fontSize: 20,
        })
        .case('num32', {
          fontSize: 32,
          fontWeight: 'medium',
        })
        .case('num24', {
          fontSize: 24,
        })
        .case('link', {
          color: 'brand',
          textDecoration: 'none',
          cursor: 'pointer',
          display: 'inline-block',
          fontSize: '14px',
          [disabledState]: {
            cursor: 'not-allowed',
            color: 'palette.brand.disable',
          },
          [hoverState]: {
            color: 'palette.brand.hover',
            position: 'relative',
            '&::after': TEXT_DECORATION,
          },
          [activeState]: {
            color: 'palette.brand.active',
            position: 'relative',
            '&::after': TEXT_DECORATION,
          },
        }),
    ),
  ]
}
